import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  FunnelIcon,
  MinusIcon,
  PlusIcon,
  Squares2X2Icon,
} from "@heroicons/react/20/solid";

const filters = [
  {
    id: "color",
    name: "Color",
    options: [{ value: "white", label: "White", checked: false }],
  },
];

export default function Example({ data }) {
  return (
  
   
        <main className="">
          <section aria-labelledby="products-heading" className="pb-24 pt-6">
            <div className="">
              <form className=" ">
                {data?.map((v, i) => (
                  <Disclosure key={i} as="div" className=" py-6">
                    <h3 className="-my-3 flow-root px-4 bg-gray-200">
                      <DisclosureButton className="group flex w-full items-center justify-between  py-3 text-lg font-semibold">
                        <span className="font-semibold text-gray-900">
                          {v?.question}
                        </span>
                        <span className="ml-6 flex items-center text-forging-yellow">
                          <PlusIcon
                            aria-hidden="true"
                            className="size-5 group-data-[open]:hidden"
                          />
                          <MinusIcon
                            aria-hidden="true"
                            className="size-5 group-[&:not([data-open])]:hidden"
                          />
                        </span>
                      </DisclosureButton>
                    </h3>
                    <DisclosurePanel className="pt-6  px-4">
                      <div className="space-y-4 text-mute-grey text-md ">
                        {v?.answer}
                      </div>
                    </DisclosurePanel>
                  </Disclosure>
                ))}
              </form>

              {/* Product grid */}
              <div className="lg:col-span-3">{/* Your content */}</div>
            </div>
          </section>
        </main>
    

  );
}
